<template>
  <ProductCardDetails :product-id="listing.productId" :without-header="true" />
</template>

<script setup lang="ts">
import type { Listing } from '@backmarket/http-api/src/api-specs-seller-backoffice/merchants/listings.types'

import ProductCardDetails from '~/scopes/listings/pages/product-search/components/ProductCard/components/ProductCardDetails/ProductCardDetails.vue'

defineProps<{
  listing: Listing
}>()
</script>
